<template>
  <div :class="`row-question ${divStyle}`">
    <div class="block block--gray">
      <div class="container px-4 question">
        <h3>{{ translate.questionTitle }}</h3>
        <div class="txt-html" v-html="perfilQuestion"></div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import translateModel from "@/tradutors/model";

const props = defineProps(["model", "divStyle", "perfilModel"]);
const perfilQuestion = computed(() => props.perfilModel.profileQuestion);
const route = useRoute();
const translate = computed(() =>
  route.params.language == "pt-br"
    ? translateModel.portugues
    : translateModel.ingles
);
</script>
<style scoped lang="css">
h3 h1 p {
  font-family: "Exo-2";
}

h3 {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.title {
  color: #000000;
  font-family: "Bebas-Neue";
  font-size: 72px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 72px;
}

.description {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.text {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  max-width: 500px;
}

.questio div {
  opacity: 0.7;
  color: #444444;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}
.model-info {
  padding-left: 110px;
}

.row .buttons-video > .col,
.row > [class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}

.img-perfil-model {
  width: 100%;
  right: -5px;
}

.txt-html {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  /* por CSS, não por isMobile(): o texto sai no HTML do SSR */
  column-count: 2;
}

@media screen and (max-width: 769px) {
  .txt-html {
    column-count: 1;
  }
}

.div-profile-hidden {
  top: -50px;
  height: 300px;
  overflow: hidden;
  -webkit-mask-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(0, 0, 0, 1)),
    to(rgba(0, 0, 0, 0))
  );
}

.div-profile-show {
  top: -50px;
  height: auto;
  animation-name: profile-fadein;
  animation-duration: 2s;
}

.block {
  width: 98%;
  margin: 0 auto;
}

@keyframes profile-fadein {
  0% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}

@media screen and (max-width: 992px) {
  .title {
    display: none;
  }

  .block {
    padding: 0px;
    margin-top: 0px;
  }

  .question {
    padding-right: 50px !important;
  }

  .block--gray {
    padding-top: 50px;
  }

  .model-data {
    border-radius: 30px;
    top: -80px;
    z-index: 1;
    background-color: white;
    right: -15px;
    padding-left: 40px !important;
  }

  .model-info {
    padding-left: 10px;
  }
  .img-perfil-model,
  .row-question {
    right: 0px;
  }
}
</style>
